// extracted by mini-css-extract-plugin
export default {"header":"_39TR_"};